import { action, thunk } from 'easy-peasy';
import * as commonService from '../../services/common';

const commonModel = {
  snackbar: {
    open: false,
    status: false,
    messages: '',
  },

  setSubmitSnackbar: action((state, payload) => {
    state.snackbar = payload;
  }),

  getTenantList: thunk(async (actions, payload) => {
      return await commonService.getTenantList(payload)
        .then(function (response) {
          return response;
        })
        .catch(function (error) {
          // console.log('Error', error);
          throw error;
        });
    }),
};

export default commonModel;
